import { render, staticRenderFns } from "./quizResult.vue?vue&type=template&id=32a638f0"
import script from "./quizResult.vue?vue&type=script&lang=js"
export * from "./quizResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports